export enum CalendarRangeType {
  RANGO_DIAS = 'RANGO_DIAS',
  RANGO_MESES = 'RANGO_MESES',
  ANIO_ACTUAL = 'ANIO_ACTUAL',
  ANIO_ANTERIOR = 'ANIO_ANTERIOR',
  MES_ACTUAL = 'MES_ACTUAL',
  MES_ANTERIOR = 'MES_ANTERIOR',
  SEMANA_ANTERIOR = 'SEMANA_ANTERIOR',
  DIA_ESPECIFICO = 'DIA_ESPECIFICO',
  DIA_ANTERIOR = 'DIA_ANTERIOR'
}

export enum CalendarOptionValue {
  SEMANA_ANTERIOR = 'semana_anterior',
  MES_ACTUAL = 'este_mes',
  MES_ANTERIOR = 'mes_anterior',
  ANIO_ACTUAL = 'este_año',
  ANIO_ANTERIOR = 'anio_anterior',
  RANGO_DIAS = 'range',
  RANGO_MESES = 'monthRange',
  DIA_ANTERIOR = 'previousDay',
  DIA_ESPECIFICO = 'date'
}

export interface CalendarRangeOutput {
  tipo: CalendarRangeType;
  date?: string;
  fechaInicio?: string;
  fechaFin?: string;
}

export interface DateRange {
  startDate: string;
  endDate: string;
}

export interface DateRangeSelected {
  start: Date | null;
  end: Date | null;
}

export interface Dates {
  fecha_inicial: string;
  fecha_final: string;
}
